
















import { computed } from '@vue/composition-api';
import innerUserManagement from '@/renderer/views/desktop/ManageConsole/UserManagement/innerUser/innerUser.vue';
import externalUserManagement from '@/renderer/views/desktop/ManageConsole/UserManagement/externalUser/extUser.vue';
import { PAY_PLAN_MAP } from '@/renderer/scripts/utils/ConstantConfig';
import store from '@/renderer/store';
export default {
  name: 'userTabs',
  components: {
    innerUserManagement,
    externalUserManagement,
  },
  setup() {
    const isShowTemporary = computed(
      () =>
        store.getters.editionFlag === PAY_PLAN_MAP.EnterPrise &&
        store.getters.allowPhoneLogin &&
        !store.getters.onlyPasswordLogin,
    );
    return {
      value: 'member',
      isShowTemporary,
    };
  },
};
